var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.38462C0.5 0.688783 1.07645 0 1.94755 0H17.0524C17.9235 0 18.5 0.688783 18.5 1.38462V16.6154C18.5 17.3112 17.9235 18 17.0524 18H1.94755C1.07646 18 0.5 17.3112 0.5 16.6154V1.38462ZM2.13636 1.5V16.5H16.8636V1.5H2.13636ZM4.59139 4.87497C4.59139 4.46075 4.9577 4.12497 5.40957 4.12497H13.5914C14.0433 4.12497 14.4096 4.46075 14.4096 4.87497C14.4096 5.28918 14.0433 5.62497 13.5914 5.62497H5.40957C4.9577 5.62497 4.59139 5.28918 4.59139 4.87497ZM4.59139 9.00004C4.59139 8.58582 4.9577 8.25004 5.40957 8.25004H13.5914C14.0433 8.25004 14.4096 8.58582 14.4096 9.00004C14.4096 9.41425 14.0433 9.75004 13.5914 9.75004H5.40957C4.9577 9.75004 4.59139 9.41425 4.59139 9.00004ZM4.59139 13.125C4.59139 12.7108 4.9577 12.375 5.40957 12.375H8.47776C8.92963 12.375 9.29594 12.7108 9.29594 13.125C9.29594 13.5392 8.92963 13.875 8.47776 13.875H5.40957C4.9577 13.875 4.59139 13.5392 4.59139 13.125Z",
    fill: "#00B9E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.da9753f9.svg";
export { ForwardRef as ReactComponent };